import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import HotelSearchFormCard from "../hotelsearch/HotelSearchFormCard";
import { Location } from "../../../Models";
import HotelSearchFormState from "../../../states/HotelSearchFormState";
import HotelSearchCriteria from "../../../states/HotelSearchCriteria";
import './HomePage.css'
import TemplateContentFrame from "./TemplateContentFrame";

interface Attrs {    
    hotelSearchFormState: HotelSearchFormState,
    locations : Location[],
    messageProvider: MessageProvider;
    bannerImageUrl: string;
    extraContentTemplateId: string|null;
    onSearch: (searchCriteria:HotelSearchCriteria) => void;
}

function HomePage(): m.Component<Attrs> {

    return {
        view(vnode) {    
            const {hotelSearchFormState, locations, messageProvider, bannerImageUrl, extraContentTemplateId, onSearch} = vnode.attrs;    

            return [
                m("div.hero-banner-grid",{}, [
                    m("img.hero-banner-image", {
                        src: bannerImageUrl
                    }),
                    m("div.hero-banner-title-area _d-flex _align-items-end", 
                        m(ContainerRowCol,                         
                            m("h1", "Book Your Stay Without Hassle.")
                        )                        
                    ),
                    m("div.hero-banner-form-area", 
                        m(ContainerRowCol,   
                            m(HotelSearchFormCard, {
                                messageProvider : messageProvider,
                                locations: locations,
                                searchCriteria: hotelSearchFormState.toHotelSearchCriteria(),
                                onSearch: function(searchCriteria){
                                    console.log(searchCriteria)
                                    onSearch(searchCriteria);
                                }
                            })                            
                        )
                    ),                                     
                ]),

                (extraContentTemplateId != null)?
                m(TemplateContentFrame, {
                    templateId: extraContentTemplateId
                }): null
            ]
            
            
        }
    }
}

function ContainerRowCol(): m.Component<{}>  {
    return {
        view: function(vnode) {
            return m("div.mx-5", [
                m("div.row mx-5", 
                    m("div.col", vnode.children)
                )
            ]) 
        }
    }
}


export default HomePage;

